import { render, staticRenderFns } from "./OP_ByPatientTypePrintable.vue?vue&type=template&id=4da0d471&scoped=true&"
import script from "./OP_ByPatientTypePrintable.vue?vue&type=script&lang=js&"
export * from "./OP_ByPatientTypePrintable.vue?vue&type=script&lang=js&"
import style0 from "./OP_ByPatientTypePrintable.vue?vue&type=style&index=0&id=4da0d471&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0d471",
  null
  
)

export default component.exports